import { render, staticRenderFns } from "./commandeProduitCard.vue?vue&type=template&id=58f06f68&scoped=true&lang=pug&"
import script from "./commandeProduitCard.vue?vue&type=script&lang=js&"
export * from "./commandeProduitCard.vue?vue&type=script&lang=js&"
import style0 from "./commandeProduitCard.vue?vue&type=style&index=0&id=58f06f68&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58f06f68",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VImg,VRow})
